import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MapIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.45251 19.8899H18.5475V21.7349H5.45251V19.8899ZM10.11 8.63989C10.11 9.1499 10.2975 9.58489 10.6725 9.94489C11.0475 10.3049 11.4938 10.4849 12.0113 10.4849C12.5288 10.4849 12.9713 10.3049 13.3388 9.94489C13.7063 9.58489 13.89 9.1499 13.89 8.63989C13.89 8.12989 13.7025 7.68739 13.3275 7.31239C12.9525 6.93739 12.51 6.74989 12 6.74989C11.49 6.74989 11.0475 6.93739 10.6725 7.31239C10.2975 7.68739 10.11 8.12989 10.11 8.63989ZM17.625 8.63989C17.625 9.4199 17.43 10.3124 17.04 11.3174C16.71 12.1724 16.245 13.0949 15.645 14.0849C15.165 14.8649 14.61 15.6749 13.98 16.5149C13.53 17.1149 13.065 17.6924 12.585 18.2474L12 18.9224L11.415 18.2474C10.935 17.6924 10.47 17.1149 10.02 16.5149C9.39001 15.6749 8.83502 14.8649 8.35501 14.0849C7.75501 13.0949 7.29002 12.1724 6.96001 11.3174C6.57001 10.3124 6.37501 9.4199 6.37501 8.63989C6.37501 7.61989 6.62626 6.67865 7.12876 5.81614C7.63127 4.95364 8.31376 4.27115 9.17626 3.76864C10.0388 3.26614 10.98 3.01489 12 3.01489C13.02 3.01489 13.9613 3.26614 14.8238 3.76864C15.6863 4.27115 16.3688 4.95364 16.8713 5.81614C17.3738 6.67865 17.625 7.61989 17.625 8.63989Z'
        />
    ),
})

MapIcon.displayName = 'MapIcon'
